import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Su ostukorv on tühi

  <span style="color:#85c1dc;">**FI:**</span>
  Ostoskori on tyhjä

  <span style="color:#85c1dc;">**RU:**</span>
  Ваша корзина пуста
*/
/* @__NO_SIDE_EFFECTS__ */
const m1068 = msg(
  mf`Su ostukorv on tühi`,
  mf`Ostoskori on tyhjä`,
  mf`Ваша корзина пуста`,
)

export { m1068 as 'w.basket.empty.title' }